import React, { Component, Fragment } from 'react';

import {
  SectionWrapper,
  UploadConfirm,
  BankAccountModal
} from '../../../views/Employee/FiscalData';

import AddressForm from '../../../views/Employee/FiscalData/addressForm';

import {
  Section,
  TitleSection,
  TooltipElement,
  AccordionDataSection
} from '../../../views/Employee/FiscalData/IRPFData';

import { StatusMessage } from './common';

import Loading from '../../../core/Loading';
import Button from '../../../core/Buttons';

import {
  getAddressFromChangeRequest,
  getAddress,
  createAddressChangeRequest,
  updateAddressChangeRequest,
  deleteAddressChangeRequest
} from '../../../../utils/apiFiscalData';
import { getDataFormatted } from '../../../../utils/address';

import { userAddress, dataSectionAddress } from '../../../../constants/user';

import {
  StyledAlignRight,
  StatusMessageWrapper,
  StyledTwoLevelBreadcrumb
} from './style';

class AddressSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: `${this.props.page ? this.props.page : 'Resume'}`,
      address: null,
      editedAddress: null,
      cancelling: false,
      pending: false,
      isLoading: true,
      onErrorLoadData: false
    };
  }

  componentDidMount() {
    const { page } = this.state;
    if (page !== 'Create') {
      getAddressFromChangeRequest()
        .then(editedAddress => {
          this.setState({
            pending: true,
            editedAddress
          });
        })
        .catch(error => {
          if (error.code === 404) {
            this.setState({ pending: false });
          }
          throw error;
        });

      getAddress()
        .then(address => {
          this.setState({ address, isLoading: false });
        })
        .catch(error => {
          this.setState({
            onErrorLoadData: true
          });
          throw error;
        })
        .finally(() => {
          this.setState({ isLoading: false });
        });
    } else {
      this.setState({ isLoading: false });
    }
  }

  addressChangeRequest = userAddress => {
    const { pending } = this.state;
    const service = !pending
      ? createAddressChangeRequest
      : updateAddressChangeRequest;

    this.setState({
      isLoading: true,
      page: 'Confirm',
      editedAddress: userAddress
    });

    service(userAddress)
      .then(() => {
        this.setState({
          pending: true,
          page: 'Confirm'
        });
      })
      .catch(error => {
        if (error.code === 400) {
          console.warn('error al crear o actualizar dirección');
        }
        throw error;
      })
      .finally(() => {
        this.setState({
          isLoading: false
        });
      });
  };

  cancelAddressChangeRequest = () => {
    this.setState({
      cancelling: false,
      isLoading: true
    });

    deleteAddressChangeRequest()
      .then(() => {
        this.setState({
          pending: false,
          page: 'Resume'
        });
      })
      .catch(error => {
        throw error;
      })
      .finally(() => {
        this.setState({
          isLoading: false
        });
      });
  };

  getRender = () => {
    const {
      page,
      pending,
      cancelling,
      address,
      editedAddress,
      onErrorLoadData
    } = this.state;
    const { onClose, formUser, cancel } = this.props;

    if (onErrorLoadData) {
      return <p>Lo sentimos, pero no existen datos para su usuario</p>;
    }

    return (
      <SectionWrapper>
        {page === 'Resume' && (
          <Fragment>
            {pending && (
              <StatusMessageWrapper>
                <StatusMessage
                  text={userAddress.pending}
                  onEdit={() =>
                    this.setState({
                      page: 'Edit'
                    })
                  }
                  onDelete={() =>
                    this.setState({
                      cancelling: true
                    })
                  }
                />
              </StatusMessageWrapper>
            )}
            <Section>
              <TitleSection>
                <TooltipElement text={dataSectionAddress.title} />
              </TitleSection>
              {address.idSiglaDomicilio && (
                <AccordionDataSection
                  title={dataSectionAddress.label.dirección}
                  body={`${getDataFormatted(
                    address.idSiglaDomicilio,
                    'addressType'
                  ) || ''} ${address.viaPublica || ''}, ${address.numeroVia ||
                    ''}`}
                  span={0}
                />
              )}
              {address.bloque && (
                <AccordionDataSection
                  title={dataSectionAddress.label.bloque}
                  body={address.bloque}
                  span={0}
                />
              )}
              {address.piso && (
                <AccordionDataSection
                  title={dataSectionAddress.label.piso}
                  body={address.piso}
                  span={0}
                />
              )}
              {address.escalera && (
                <AccordionDataSection
                  title={dataSectionAddress.label.escalera}
                  body={address.escalera}
                  span={0}
                />
              )}
              {address.puerta && (
                <AccordionDataSection
                  title={dataSectionAddress.label.puerta}
                  body={address.puerta}
                  span={0}
                />
              )}
              {address.distritoPostal && (
                <AccordionDataSection
                  title={dataSectionAddress.label.cp}
                  body={address.distritoPostal}
                  span={0}
                />
              )}
              {address.poblacion && (
                <AccordionDataSection
                  title={dataSectionAddress.label.poblacion}
                  body={address.poblacion}
                  span={0}
                />
              )}
              {address.subdivGeo && (
                <AccordionDataSection
                  title={dataSectionAddress.label.provincia}
                  body={getDataFormatted(`${address.subdivGeo}`, 'provinces')}
                  span={0}
                />
              )}

              {address.nacion && (
                <AccordionDataSection
                  title={dataSectionAddress.label.pais}
                  body={getDataFormatted(address.nacion, 'countries')}
                  span={0}
                />
              )}
              {address.telefono && (
                <AccordionDataSection
                  title={dataSectionAddress.label.telefono}
                  body={address.telefono}
                  span={0}
                />
              )}
              {address.email && (
                <AccordionDataSection
                  title={dataSectionAddress.label.email}
                  body={address.email}
                  span={0}
                />
              )}
            </Section>
            <StyledAlignRight>
              <Button
                secondary
                fixed
                onClick={() => cancel()}
                disabled={pending}
              >
                {userAddress.backButton}
              </Button>
              <Button
                secondary
                fixed
                onClick={() => this.setState({ page: 'Edit' })}
                disabled={pending}
              >
                {userAddress.editButton}
              </Button>
            </StyledAlignRight>
          </Fragment>
        )}
        {page === 'Create' && (
          <Fragment>
            <StyledTwoLevelBreadcrumb
              first={userAddress.breadcrumb.first}
              second={userAddress.breadcrumb.second}
              onBack={() => {
                this.setState({
                  page: 'Resume'
                });
              }}
            />
            {formUser ? (
              <AddressForm
                formUser
                onSend={this.addressChangeRequest}
                onBack={onClose}
                address={{
                  idSiglaDomicilio: '',
                  viaPublica: '',
                  numeroVia: '',
                  bloque: '',
                  piso: '',
                  puerta: '',
                  escalera: '',
                  distritoPostal: '',
                  poblacion: '',
                  subdivGeo: '',
                  nacion: '',
                  telefono: ''
                }}
              />
            ) : (
              <AddressForm
                onSend={this.addressChangeRequest}
                onBack={() => {
                  this.setState({
                    page: 'Resume'
                  });
                }}
                address={{
                  idSiglaDomicilio: '',
                  viaPublica: '',
                  numeroVia: '',
                  bloque: '',
                  piso: '',
                  puerta: '',
                  escalera: '',
                  distritoPostal: '',
                  poblacion: '',
                  subdivGeo: '',
                  nacion: '',
                  telefono: '',
                  email: ''
                }}
              />
            )}
          </Fragment>
        )}
        {page === 'Edit' && (
          <Fragment>
            <StyledTwoLevelBreadcrumb
              first={userAddress.breadcrumb.first}
              second={userAddress.breadcrumb.second}
              onBack={() => {
                this.setState({
                  page: 'Resume'
                });
              }}
            />
            <AddressForm
              onSend={this.addressChangeRequest}
              onBack={() => {
                this.setState({
                  page: 'Resume'
                });
              }}
              address={pending ? editedAddress : address}
              pending={pending}
            />
          </Fragment>
        )}
        {page === 'Confirm' && !formUser && (
          <UploadConfirm
            onClick={() => this.setState({ page: 'Resume' })}
            title={userAddress.addressConfirm.title}
            txt={userAddress.addressConfirm.txt}
          />
        )}
        {page === 'Confirm' && formUser && (
          <UploadConfirm
            onClick={onClose}
            title={userAddress.addressConfirm.title}
            txt={userAddress.addressConfirm.txt}
          />
        )}
        {cancelling && (
          <BankAccountModal
            onCancel={() =>
              this.setState({
                cancelling: false
              })
            }
            onAccept={() => {
              this.cancelAddressChangeRequest();
            }}
          />
        )}
      </SectionWrapper>
    );
  };

  render() {
    const { isLoading } = this.state;

    return isLoading ? <Loading /> : this.getRender();
  }
}

export default AddressSection;
